/* PLN: configured rate. EUR: market rate rounded up to x.95, the same way the DE market rounds the rate at checkout
   (50 PLN -> 11,95 EUR). Other currencies: approximate amount; checkout shows the final amount. */
class EtolieShippingPrice extends HTMLElement {
  connectedCallback() {
    const basePrice = Number(this.dataset.basePrice);
    if (!Number.isFinite(basePrice)) return;

    const lang = document.documentElement.lang || 'pl';
    const currency = window.Shopify && window.Shopify.currency;
    const rate = Number(currency && currency.rate);

    try {
      if (currency && currency.active === 'EUR' && Number.isFinite(rate) && rate > 0) {
        const rounded = Math.ceil(basePrice * rate - 0.95 - 1e-9) + 0.95;
        this.textContent = new Intl.NumberFormat(lang, { style: 'currency', currency: 'EUR' }).format(rounded);
        return;
      }

      if (currency && currency.active && currency.active !== 'PLN' && Number.isFinite(rate) && rate > 0) {
        const approx = { pl: 'ok.', de: 'ca.' }[lang.slice(0, 2)] || 'approx.';
        const amount = new Intl.NumberFormat(lang, { style: 'currency', currency: currency.active }).format(basePrice * rate);
        this.textContent = `${approx} ${amount}`;
        return;
      }

      this.textContent = new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: 'PLN',
      }).format(basePrice);
    } catch {
      // Keep the explicit PLN amount when the browser cannot format this currency.
    }
  }
}

if (!customElements.get('etolie-shipping-price')) {
  customElements.define('etolie-shipping-price', EtolieShippingPrice);
}
